export default {
      id: "play-usage",
      viewBox: "0 0 148 148",
      url: "../../assets/" + "sprite.svg#play-usage",
      toString: function () {
        return this.url;
      }
    }